import React from 'react';
import Recommendation from './recommendation';
import { recShape } from './recommendation_mapper';

const TopicRecommendation = ({ rec }) => {
  const headline = 'Drive more traffic with topics your audience loves';
  const strongTopic = <strong>{rec.primaryItem.name}</strong>;

  return (
    <Recommendation headline={headline} rec={rec}>
      {'Content covering '}
      {strongTopic}
      {' has generated above-average '}
      {rec.metric}
      {'. Update your content plan to create more content related to '}
      {strongTopic}
      {'.'}
    </Recommendation>
  );
};

export default TopicRecommendation;

TopicRecommendation.propTypes = {
  rec: recShape.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/topic_recommendation.jsx